<div class="about-section">
    <div class="container">
        <div class="row align-items-center m-1">
            <!-- Left Side: Text -->
            <div class="col-md-7 col-12 about-text">
                <h2>The Gymnastics Program</h2>
                <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
                <p>
                    The Gymnastics Program at Innovative Vision is a fundamental pillar of our holistic development
                    approach, designed to build a strong foundation of physical and mental resilience in young children.
                    It goes beyond simple exercise, using playful movements and structured activities to enhance a
                    child's flexibility, coordination, and body control, all while nurturing their confidence and
                    discipline.
                </p>
            </div>
            <!-- Right Side: Image -->
            <div class="col-md-5 col-12 text-center about-img">
                <img src="assets/ivimg/programDetails/gemnF.svg" alt="Girl Learning Pottery" class="img-fluid">
            </div>
        </div>
    </div>
</div>
<div class="key-focus-section m-3">
    <div class="image-container">
        <img src="assets/ivimg/programDetails/gemnH.svg" alt="Key Focus Areas" />
    </div>
    <div class="content">
        <h2 class="section-title">Key Focus Areas</h2>
        <div class="points">
            <p>
                <strong>1. Physical Development:</strong>Our curriculum is meticulously designed to improve crucial
                physical attributes. We focus on developing flexibility, strength, balance, and coordination through a
                variety of exercises and routines. These skills are essential for all sports and activities and
                contribute to a child's overall health.
            </p>
            <p>
                <strong>2. Discipline & Mental Focus:</strong> Gymnastics requires concentration and perseverance.
                Children learn to follow instructions, maintain their focus during routines, and work on mastering
                challenging skills. This training instills a sense of discipline and mental toughness that benefits them
                in all areas of life.
            </p>
            <p>
                <strong>3. Confidence & Body Awareness:</strong> As children learn to control their bodies and master
                new moves, their self-confidence soars. The program also helps them develop a strong sense of body
                awareness and spatial understanding, which is a key component of right-brain development.
            </p>
        </div>
    </div>
</div>
<div class="program-highlights">
    <div class="highlight-container">
        <!-- Image from assets -->
        <div class="image-container">
            <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
        </div>
        <!-- Text Content -->
        <div class="text-container">
            <h2 class="title">Program Highlights</h2>
            <p>
                <strong> Outcome-Based Curriculum:</strong>Our program is based on an outcome-based curriculum with a
                clear progression of skills, ensuring children are constantly challenged and motivated to improve.
            </p>
            <p>
                <strong>Safe & Supportive Environment:</strong> We provide a safe and encouraging environment where
                children feel comfortable trying new things and pushing their limits. Our trained instructors ensure
                that every child learns at their own pace.
            </p>
            <p>
                <strong>Play-Based Learning:</strong> We use games and fun drills to make learning gymnastics an
                exciting and enjoyable experience. This approach ensures children stay engaged and develop a lifelong
                positive association with physical activity.
            </p>
        </div>
    </div>
</div>
<div class="benefits-section">
    <h2 class="benefits-title">Benefits for Your Child</h2>
    <p class="benefits-text">
        Our gymnastics program offers a multitude of benefits, contributing to a child's complete well-being.
        It provides a strong foundation for physical fitness and coordination, which are essential for a
        healthy lifestyle. The program also enhances their mental focus, discipline, and perseverance,
        teaching them valuable life lessons. Furthermore, by helping them master new skills and gain
        control over their bodies, gymnastics significantly boosts their confidence and self-esteem, shaping them into
        well-rounded and resilient individuals.
    </p>
</div>